import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import RecentPost from "./RecentPost";
import NoData from "../../../../../Dashboard/Charts/NoData/NoData";

const RecentPostWrapper = (props) => {
    const { filteredData } = props;

    const [currentPost, setCurrentPost] = useState(0);
    let totlaPosts = filteredData?.posts?.length || 0;

    const nextPage = () => {
        // console.log("currentPost", currentPost, totlaPosts);
        if (currentPost + 1 < totlaPosts) setCurrentPost((prev) => prev + 1);
    };
    const previousPage = () => {
        if (currentPost > 0) setCurrentPost((prev) => prev - 1);
    };
    // console.log("filteredData", filteredData);

    return (
        <div className="individual__post__container">
            {totlaPosts > 0 ? (
                <>
                    {/* {props.isCompPage && filteredData?.posts?.length > 1 && (
                                                <div className="leftArrow" onClick={previousPage}>
                                                    <Icon name="arrow left" size="large" />
                                                </div>
                                            )} */}
                    {filteredData.posts?.length > 1 && (
                        <div className="leftArrow" onClick={previousPage}>
                            <Icon name="arrow left" size="large" />
                        </div>
                    )}
                    <div className="carousel">
                        <RecentPost data={filteredData?.posts[currentPost]} platform={filteredData?.platform} />

                        {/* {filteredData?.posts?.map((post, index) => (
                    <RecentPost key={index} data={post} platform={filteredData?.platform} />
                ))} */}
                    </div>

                    {/* {!props.isCompPage && filteredData?.[pageId]?.posts?.length > 1 && (
                                                <div className="rightArrow" onClick={nextPage}>
                                                    <Icon name="arrow right" size="large" />
                                                </div>
                                            )} */}
                    {filteredData?.posts?.length > 1 && (
                        <div className="rightArrow" onClick={nextPage}>
                            <Icon name="arrow right" size="large" />
                        </div>
                    )}
                </>
            ) : (
                <div className="no__data__container">
                    <NoData />
                </div>
            )}
        </div>
    );
};

export default RecentPostWrapper;
